module.exports = __webpack_public_path__ + "img/安评微信号.c6b39afb.c6b39afb.jpg";